const TOKEN_NAME = 'jwt-mg';

export function parseJwt(token) {
  let tokenDecoded = atob(token.split('.')[1]);
  let tokenJson = { ...JSON.parse(tokenDecoded) };
  tokenJson.apellidos = decodeURIComponent(tokenJson.apellidos);
  tokenJson.nombre = decodeURIComponent(tokenJson.nombre);
  tokenJson.uuid = decodeURIComponent(tokenJson.uuid);
  return tokenJson;
}

export function getToken() {
  return localStorage.getItem(TOKEN_NAME);
}

export function setToken(token) {
  return localStorage.setItem(TOKEN_NAME, token);
}

export function removeToken() {
  localStorage.removeItem(TOKEN_NAME);
}

export function getUsuarioFromLocalStorage() {
  let usuario = null;
  let token = getToken();
  if (token) {
    usuario = parseJwt(token);
  }
  return usuario;
}

export function isTokenExpired() {
  let token = getUsuarioFromLocalStorage();

  if (!token || !token.exp) {
    return true;
  }

  const currentDateInSeconds = Math.floor(Date.now() / 1000);

  return currentDateInSeconds > token.exp;
}
